import { render } from "./StateWaiting.vue?vue&type=template&id=d0fc2142&scoped=true"
import script from "./StateWaiting.vue?vue&type=script&lang=js"
export * from "./StateWaiting.vue?vue&type=script&lang=js"

import "./StateWaiting.vue?vue&type=style&index=0&id=d0fc2142&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0fc2142"]])

export default __exports__